/* eslint-disable prefer-const */
export default class QuantityButtons {
    constructor() {
        this.quantityContainer = [
            ...document.querySelectorAll(".quantity-wrapper .quantity"),
        ];

        if (this.quantityContainer.length) {
            this.setButtonsEvents();
        }
    }

    setButtonsEvents() {
        this.quantityContainer.forEach((item) => {
            const minusBtn = item.querySelector(".quantity-minus");
            const plusBtn = item.querySelector(".quantity-plus");
            const quantity = item.querySelector('input[type="number"]');

            if (quantity) {
                let currVal = parseInt(quantity.value, 10);

                minusBtn.addEventListener("click", () => {
                    let value = parseInt(quantity.value, 10);
                    const minVal = parseInt(quantity.min, 10);

                    if ((!minVal && value > 1) || (minVal && minVal < value)) {
                        quantity.value = value - 1;
                    } else if (minVal && minVal >= value) {
                        quantity.value = minVal;
                    } else {
                        quantity.value = value;
                    }
                });

                plusBtn.addEventListener("click", () => {
                    let value = parseInt(quantity.value, 10);
                    const maxVal = parseInt(quantity.max, 10);

                    if (!maxVal || (maxVal && value < maxVal)) {
                        quantity.value = value + 1;
                    } else {
                        quantity.value = maxVal;
                    }
                });

                // quantity.addEventListener("change", () => {
                //     const newQtyVal = parseInt(quantity.value, 10);
                //
                //     if (!isNaN(newQtyVal)) {
                //         currVal = newQtyVal === 0 ? 1 : Math.abs(newQtyVal);
                //         quantity.value = currVal;
                //     } else {
                //         quantity.value = currVal;
                //     }
                // });
                //
                // quantity.addEventListener("keyup", () => {
                //     const newQtyVal = parseInt(quantity.value, 10);
                //
                //     if (!isNaN(newQtyVal)) {
                //         currVal = newQtyVal === 0 ? 1 : Math.abs(newQtyVal);
                //         quantity.value = currVal;
                //     } else {
                //         quantity.value = currVal;
                //     }
                // });
            }
        });
    }
}
